<template class="h-100 w-100 container-table">
    <table class="w-100 text-center">
        <thead>
            <tr>
                <th class="px-1" v-if="config.item">Item</th>
                <th class="px-1" v-if="config.date">Fecha</th>
                <th class="px-1" v-if="config.date">Dirección</th>
                <th class="px-1" v-if="config.speed">Velocidad</th>
                <th class="px-1" v-if="config.odometer">Odómetro</th>
                <th class="px-1" v-if="config.event">Evento</th>
                <th class="px-1" v-if="config.battery">Batería</th>
                <th class="px-1" v-if="config.map">Mapa</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in data" :key="item.id">
                <td v-if="config.item">{{ index + 1 }}</td>
                <td class="date-field" v-if="config.date">{{ formatDate(item.deviceTime) }}</td>
                <td class="address-field" v-if="config.address" style="min-width: 300px;">{{ item.address }}</td>
                <td v-if="config.speed">{{ formatSpeed(item.speed) }}</td>
                <td v-if="config.odometer">{{ formatOdometer(getOdometer(item.attributes)) }}</td>
                <td v-if="config.event">
                    <div class="events d-flex justify-content-center align-items-center flex-row flex-wrap p-2 gap-2">
                        <img src="@/assets/img/key-green.svg" v-if="item.attributes?.ignition">
                        <img src="@/assets/img/key-red.svg" v-if="!item.attributes?.ignition">
                        <img src="@/assets/img/locked-car.svg" v-if="item.attributes?.out1 === 1 || item.attributes?.out === 1">
                        <img src="@/assets/img/charge.svg" v-if="item.attributes?.charge">
                        <img src="@/assets/img/alerts/battery_disconnect.png" v-if="item.attributes?.alarm === 'powerCut'">
                        <img src="@/assets/img/alerts/battery_connection.png" v-if="item.attributes?.alarm === 'powerRestored'">
                        <img src="@/assets/img/alerts/sos.png" v-if="item.attributes?.alarm === 'sos'">
                    </div>
                </td>
                <td v-if="config.battery">{{ formatBattery(item.attributes.power) }}</td>
                <td v-if="config.map">
                    <div class="map-link" @click="linkToMaps(item.latitude, item.longitude)">
                        <img src="@/assets/img/map-link.svg">
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script lang="ts">
import PositionDto from '@/models/dto/position.dto';
import DeviceUtil from '@/utils/device.util';
import { MapsUtil } from '@/utils/maps.util';
import DateUtil from '@/utils/date.util';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({})
export default class ReportDetailTable extends Vue {

    @Prop(Array) readonly data!: PositionDto[]
    @Prop(Object) readonly device!: any

    config = {
        item: true,
        address: true,
        date: true,
        speed: true,
        odometer: true,
        event: true,
        battery: true,
        map: true
    }

    formatSpeed(speed: number) {
        return DeviceUtil.formatKnToKmh(speed) + ' Km/h'
    }

    formatDate(date: string) {
        return DateUtil.getGenericFormat(date)
    }

    formatOdometer(odometer: number) {
        return DeviceUtil.formatOdometerFromReport(odometer)
    }

    formatBattery(battery: number) {
        if (this.device.model.includes('Concox')) {
            this.config.battery = false;
            return '';
        }
        return DeviceUtil.formatBattery(battery)
    }

    linkToMaps(lat: number, lon: number) {
        MapsUtil.openGoogleMaps(lat, lon);
    }

    getOdometer(positionAttributes: any) {
        if (this.device.attributes && this.device.attributes.services) {
            const services = this.device.attributes.services as { name: string, value: boolean }[]
            const virtualOdometer = services.find(item => item.name === 'virtual_odometer');
            if (virtualOdometer && virtualOdometer.value) {
                return positionAttributes.totalDistance;
            }
        }
        return positionAttributes.odometer;
    }
}
</script>
<style lang="sass" scoped>
    @import '@/assets/style/variables.sass'
    table,tr,th,td
        border-collapse: collapse
        border: 2px solid $primary
    th
        background: $primary 
        color: #fff
        font-weight: 400
    .map-link
        img
            height: 25px
            transition: all 0.1s ease
            &:active
                transform: scale(0.9)
    tr
        transition: all 0.1s ease
        cursor: pointer
        &:hover
            background: rgba(0, 102, 204, 0.22)
    table
        line-height: 18px
    
    .events
        img
            width: 23px
            
    @media screen and (max-width: 768px)
        table
            font-size: 12px !important
            line-height: 16px !important
        .address-field
            min-width: 100px
        .date-field
            min-width: 80px !important
            .map-link
        img
            height: 20px !important

</style>